// extracted by mini-css-extract-plugin
module.exports = {"office__city":"Office_office__city__2A5yk","office__location":"Office_office__location__2xYCz","office__address":"Office_office__address__20a-f"};